var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 7.50001C13.6315 7.49925 13.762 7.52447 13.8838 7.57424C14.0057 7.624 14.1165 7.69733 14.2099 7.79001C14.3037 7.88297 14.3781 7.99357 14.4288 8.11543C14.4796 8.23729 14.5057 8.368 14.5057 8.50001C14.5057 8.63202 14.4796 8.76273 14.4288 8.88459C14.3781 9.00645 14.3037 9.11705 14.2099 9.21001L10.8999 12.5L14.0799 15.81C14.2662 15.9974 14.3707 16.2508 14.3707 16.515C14.3707 16.7792 14.2662 17.0326 14.0799 17.22C13.987 17.3137 13.8764 17.3881 13.7545 17.4389C13.6327 17.4897 13.502 17.5158 13.3699 17.5158C13.2379 17.5158 13.1072 17.4897 12.9854 17.4389C12.8635 17.3881 12.7529 17.3137 12.6599 17.22L8.79994 13.22C8.61671 13.0331 8.51408 12.7818 8.51408 12.52C8.51408 12.2583 8.61671 12.0069 8.79994 11.82L12.7999 7.82001C12.8897 7.72308 12.9978 7.64489 13.1179 7.58997C13.2381 7.53504 13.3679 7.50447 13.4999 7.50001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementArrowLeft);
export default __webpack_public_path__ + "static/media/icon_settlement_arrow_left.cd77e9943a54b544ce854902dee37f6d.svg";
export { ForwardRef as ReactComponent };